import React from 'react';

/**
 * Reusable info box component explaining how intelligence works
 */
export default function IntelligenceInfoBox() {
  return (
    <div className="rounded-xl shadow-sm border p-6" style={{ backgroundColor: 'rgba(215, 180, 114, 0.1)', borderColor: '#D7B472' }}>
      <h3 className="font-semibold mb-3" style={{ color: '#0A0A10' }}>
        💡 How it works
      </h3>
      <ul className="space-y-2 text-sm" style={{ color: '#0A0A10', opacity: 0.8 }}>
        <li>• Paste your call transcripts, emails, or any communication samples</li>
        <li>• Our AI analyzes your communication style, tone, and preferences</li>
        <li>• The intelligence profile helps personalize AI-generated content for you</li>
        <li>• You can update your data anytime to keep your profile current</li>
        <li>• Regenerate to create a fresh intelligence profile from updated data</li>
      </ul>
    </div>
  );
}

